import React from "react";
import { useSelector } from "react-redux";
import { JobViewGrid as SharedJobViewGrid } from "tap/components/JobViewGrid";
import { useUpdateEngineActions } from "tap/store/updateEngine/updateEngine.js";

export const JobViewGrid = () => {
  const {
    isJobViewModalOpen,
    jobViewFilterForm,
    jobTasks,
    selectedJob,
    taskStatusOptions,
    pendingStatuses,
    jobViewItemsPerPage,
  } = useSelector((state) => state.updateEngine);

  const { updateUpdateEngine, updateUpdateEngineSearchForm } =
    useUpdateEngineActions();

  return (
    <SharedJobViewGrid
      isJobViewModalOpen={isJobViewModalOpen}
      jobViewFilterForm={jobViewFilterForm}
      jobTasks={jobTasks}
      selectedJob={selectedJob}
      taskStatusOptions={taskStatusOptions}
      pendingStatuses={pendingStatuses}
      updateStore={updateUpdateEngine}
      updateSearchForm={updateUpdateEngineSearchForm}
      isLicensingJob={false}
      columnDefsKey="jobViewTasks"
      tasksFieldName="jobTasks"
      itemsPerPage={jobViewItemsPerPage}
    />
  );
};
